import { mapGetters } from 'vuex';

import jobCommentItem from './jobCommentItem/index.vue';
import jobCommentForm from './jobCommentForm/index.vue';
import pagination from '@/components/pagination/index.vue';
import preloader from '@/components/preloader/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  components: {
    jobCommentItem,
    jobCommentForm,
    pagination,
    preloader,
  },
  mixins: [
    helpers.general,
  ],
  props: {
    accountTypes: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      jobCommentsData: [],
      jobCommentsDataResponse: [],

      query: {
        page: 1,
        ppage: 6,
      },

      load: true,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    jobComponent () {
      return this.checkPermissions('job', 'job-comment-add');
    },
  },
  created () {
    this.getComments();
  },
  methods: {
    /**
         * Method for gettings all comments
         */
    getComments () {
      this.load = true;

      const params = {
        jobID: this.$route.params.id,
        ...this.query,
      };

      Api.jobs.comments
        .getComments(params)
        .then((response) => {
          if (!response.data.Status) {
            this.jobCommentsData = response.data.Data;
            this.jobCommentsDataResponse = response.data;
            this.load = false;
          }
        });
    },

    /**
         * Method for refresh comments and check page
         */
    removeComment () {
      if (this.jobCommentsData.length === 1) {
        this.query.page = this.query.page > 1 ? this.query.page - 1 : this.query.page;
      }
      this.getComments();
    },

    /**
         * Send comment
         */
    sendComment () {
      if (this.jobCommentsDataResponse.Total === this.jobCommentsDataResponse.PerPage * this.jobCommentsDataResponse.CurrentPage ||
                this.jobCommentsDataResponse.LastPage === 0) {
        this.query.page = this.jobCommentsDataResponse.LastPage + 1;
      } else {
        this.query.page = this.jobCommentsDataResponse.LastPage;
      }

      return this.getComments();
    },

    /**
         * Send page for pagination
         *
         * @param {Number} page
         */
    sendPage (page) {
      this.query.page = page;
      this.getComments();
    },
  },
};
